module.exports = __webpack_public_path__ + "fb76987e58d87f60905c44cac95d64de.svg";